import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    fetched: false,
    available_goods: [],
    goods_remains: [],
    itemsTotalCount: null,
    is_fetched_nomenclature_remains: false,
    nomenclature_remains: null,
    search: '',
    tableOptions: {
      page: 1,
      last_page: 1,
      itemsPerPage: 10,
      sortBy: ["id"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async getNomenclatureRemains({ commit, state, dispatch }, payload) {
      updateField(state, {path: 'is_fetched_nomenclature_remains', value: false});
      updateField(state, {path: 'nomenclature_remains', value: null});
      return await axios
          .get(this._vm.$apiURL + `/goods_nomenclature/remains/`+payload.id, {
            params:{
              storage_id: payload.storage_id,
              operation: payload.operation,
            }
          })
          .then((response) => {
            updateField(state, {path: 'nomenclature_remains', value: response.data.data});
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, {path: 'is_fetched_nomenclature_remains', value: true});
          });
    },
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + `/goods_remains`, {
          params: {
            find_string: state.search,
            page: state.tableOptions.page,
            itemsPerPage: state.tableOptions.itemsPerPage,
            sortBy: state.tableOptions.sortBy[0],
            sortDesc: state.tableOptions.sortDesc[0],
            storages: (payload && payload.storages) ? payload.storages.join(',') : '',
          },
        })
        .then((response) => {
          updateField(state, { path: 'goods_remains', value: response.data.data });
          updateField(state, {
            path: "itemsTotalCount",
            value: parseInt(response.data.total),
          });
          updateField(state, {
            path: "tableOptions.page",
            value: parseInt(response.data.current_page),
          });
          updateField(state, {
            path: "tableOptions.last_page",
            value: parseInt(response.data.last_page),
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async selectGoodsForReserve({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      updateField(state, { path: "available_goods", value: [] });
      return await axios
          .get(this._vm.$apiURL + `/goods_remains/select`, {
            params: {
              brand: payload.brand,
              part_number: payload.part_number,
              amount: payload.amount
            },
          })
          .then((response) => {
            updateField(state, { path: 'available_goods', value: response.data.data });
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "fetched", value: true });
          });
    },
  },
};
